const EDC = {};
EDC.Scenes = {};
EDC.Animations = {};
EDC.UI = {};
EDC.Signals = {};
EDC.Preloaders = {};
EDC.Settings = {
  StarsPercentsRange: [100, 75, 40],
  BackgroundsCount: 16,
};

EDC.SortTypes = {
  ST_ASCENDING: 'ASCENDING',
  ST_DESCENDING: 'DESCENDING',
};

EDC.DefaultPositions = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  TOP_CENTER: 'TOP_CENTER',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
  BOTTOM_CENTER: 'BOTTOM_CENTER',
  CENTER: 'CENTER',
  LEFT_CENTER: 'LEFT_CENTER',
  RIGHT_CENTER: 'RIGHT_CENTER',
};

EDC.RPG = {
  MAP_TILE_POSITION: {
    CENTER: 'CENTER',
    TOP_LEFT: 'TOP_LEFT',
  },
  HERO_FACE_DIRECTION: {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    UP: 'UP',
    DOWN: 'DOWN',
  },
  // possible actions for interactive objects
  ACTIONS: {
    READ: 'READ', // For reading text. Text will show like "bubble" message
    OPEN_LOCATION: 'OPEN_LOCATION', // For opening doors/teleposts for directiong to other locaions.
    OPEN: 'OPEN', // For opening
    PICK_UP: 'PICK_UP', // For picking up objects to inventory
    LOOK: 'LOOK', // For looking at something (get description of object or other stuff)
    TALK: 'TALK', // for making dialogs
  },
  Scenes: {},
};

// NAMESPACES
EDC.Games = {
  Assignments: {
    Scenes: {},
  },
  Badges: {
    Scenes: {},
  },
  TitleIntro: {
    Scenes: {},
  },
  WelcomePage: {
    Scenes: {},
  },
  WelcomeBackPage: {
    Scenes: {},
  },
  TitleMenu: {
    Config: {
      bgList: null,
    },
    Scenes: {},
  },
  // initial state of profile creation flow
  GradeSelect: {
    Config: {
      bgList: ['newgame_bg'],
    },
    Scenes: {},
  },
  GenderSelect: {
    Scenes: {},
  },
  AvatarSelect: {
    Config: {
      signals: {
        S_ITEM_ACTIVATED: 'S_ITEM_ACTIVATED',
        S_FILTER_ACTIVATED: 'S_FILTER_ACTIVATED',
      },
      cropSize: { width: 182, height: 182 },
      types: [
        {
          type: 'all',
          imgNormal: 'types/all-normal.png',
          imgLight: 'types/all-light.png',
        },
        {
          type: 'human',
          imgNormal: 'types/humans-normal.png',
          imgLight: 'types/humans-light.png',
        },
        {
          type: 'animal',
          imgNormal: 'types/animals-normal.png',
          imgLight: 'types/animals-light.png',
        },
        {
          type: 'monster',
          imgNormal: 'types/monsters-normal.png',
          imgLight: 'types/monsters-light.png',
        },
      ],
      avatars: [
        {
          id: 1,
          type: 'human',
          gender: 'boy',
          crop: { x: 180, y: 50 },
          img: 'avatars/humans/Human_01.png',
        },
        {
          id: 2,
          type: 'human',
          gender: 'girl',
          crop: { x: 180, y: 50 },
          img: 'avatars/humans/Human_02.png',
        },
        {
          id: 3,
          type: 'human',
          gender: 'boy',
          crop: { x: 240, y: 50 },
          img: 'avatars/humans/Human_03.png',
        },
        {
          id: 4,
          type: 'human',
          gender: 'girl',
          crop: { x: 140, y: 50 },
          img: 'avatars/humans/Human_04.png',
        },
        {
          id: 5,
          type: 'human',
          gender: 'boy',
          crop: { x: 180, y: 50 },
          img: 'avatars/humans/Human_05.png',
        },
        {
          id: 6,
          type: 'human',
          gender: 'girl',
          crop: { x: 140, y: 50 },
          img: 'avatars/humans/Human_06.png',
        },
        {
          id: 7,
          type: 'human',
          gender: 'boy',
          crop: { x: 110, y: 80 },
          img: 'avatars/humans/Human_07.png',
        },

        {
          id: 8,
          type: 'animal',
          gender: 'girl',
          crop: { x: 180, y: 80 },
          img: 'avatars/animals/Animal_01.png',
        },
        {
          id: 9,
          type: 'animal',
          gender: 'girl',
          crop: { x: 140, y: 50 },
          img: 'avatars/animals/Animal_02.png',
        },
        {
          id: 10,
          type: 'animal',
          gender: 'girl',
          crop: { x: 60, y: 50 },
          img: 'avatars/animals/Animal_03.png',
        },
        {
          id: 11,
          type: 'animal',
          gender: 'girl',
          crop: { x: 120, y: 100 },
          img: 'avatars/animals/Animal_04.png',
        },
        {
          id: 12,
          type: 'animal',
          gender: 'girl',
          crop: { x: 120, y: 50 },
          img: 'avatars/animals/Animal_05.png',
        },
        {
          id: 13,
          type: 'animal',
          gender: 'boy',
          crop: { x: 20, y: 20 },
          img: 'avatars/animals/Animal_07.png',
        },

        {
          id: 15,
          type: 'monster',
          gender: 'boy',
          crop: { x: 180, y: 50 },
          img: 'avatars/monsters/Monster_01.png',
        },
        {
          id: 16,
          type: 'monster',
          gender: 'girl',
          crop: { x: 150, y: 10 },
          img: 'avatars/monsters/Monster_02.png',
        },
        {
          id: 17,
          type: 'monster',
          gender: 'boy',
          crop: { x: 120, y: 80 },
          img: 'avatars/monsters/Monster_03.png',
        },
        {
          id: 18,
          type: 'monster',
          gender: 'boy',
          crop: { x: 120, y: 50 },
          img: 'avatars/monsters/Monster_04.png',
        },
        {
          id: 19,
          type: 'monster',
          gender: 'boy',
          crop: { x: 120, y: 50 },
          img: 'avatars/monsters/Monster_05.png',
        },
        {
          id: 20,
          type: 'monster',
          gender: 'boy',
          crop: { x: 120, y: 120 },
          img: 'avatars/monsters/Monster_06.png',
        },
        {
          id: 21,
          type: 'monster',
          gender: 'boy',
          crop: { x: 180, y: 50 },
          img: 'avatars/monsters/Monster_07.png',
        },
        {
          id: 22,
          type: 'monster',
          gender: 'boy',
          crop: { x: 140, y: 60 },
          img: 'avatars/monsters/Monster_08.png',
        },
      ],
    },
    Scenes: {},
  },
  NameSelect: {
    Config: {
      signals: {
        S_WAND_RAYS_DONE: 'S_WAND_RAYS_DONE',
      },
      names: {
        firstNames: [
          'Frost',
          'Fury',
          'Golden',
          'Great',
          'Grim',
          'Heart',
          'Ice',
          'Light',
          'Moon',
          'Night',
          'Noble',
          'Raven',
          'Sharp',
          'Silver',
          'Steel',
          'Storm',
          'Sun',
          'Swift',
          'Water',
          'Wild',
          'Wind',
          'Wolf',
          'Titan',
          'Spirit',
          'Battle',
        ],
        lastNames: [
          'Lord',
          'Master',
          'Prince',
          'Redeemer',
          'Shade',
          'Shadow',
          'Shield',
          'Storm',
          'Stride',
          'Strike',
          'Talon',
          'Thorn',
          'Roar',
          'Tail',
          'Chaser',
          'Might',
        ],
      },
    },
    Scenes: {},
  },
  ProfileSummary: {
    Scenes: {},
  },
  ProfileCreated: {
    Scenes: {},
  },
  GameTypePicker: {
    Scenes: {},
  },
  GameKickoff: {
    Scenes: {},
  },
  AutoContinue: {
    Scenes: {},
  },
  NextGamePicker: {
    Scenes: {},
  },
  ColorsMatching: {
    GameData: {},
    Scenes: {},
  },
  BiggerThan: {
    GameData: {},
    Scenes: {},
  },
  CountingCurrency: {
    GameData: {},
    Scenes: {},
  },
  CountingMoney: {
    GameData: {},
    Scenes: {},
  },
  ShapeNames: {
    GameData: {},
    Scenes: {},
  },
  MatchingChests: {
    Clocks: {},
    GameData: {},
    Scenes: {},
  },
  MatchingClocks: {
    Clocks: {},
    GameData: {},
    Scenes: {},
  },
  CountingItems: {
    GameData: {},
    Scenes: {},
  },
  LettersAlphabetical: {
    GameData: {},
    Scenes: {},
  },
  CountingUpDown: {
    GameData: {},
    Scenes: {},
  },
  NumberNames: {
    GameData: {},
    Scenes: {},
  },
  BiggestSmallestShapes: {
    GameData: {},
    Scenes: {},
  },
  SequencingFrame: {
    GameData: {},
    Scenes: {},
  },
  DaysOfWeek: {
    GameData: {},
    Scenes: {},
  },
  MonthsOfYear: {
    GameData: {},
    Scenes: {},
  },
  ImagesToTextSpace: {
    GameData: {},
    Scenes: {},
  },
  IdentifyActions: {
    GameData: {},
    Scenes: {},
  },
  CountingDots: {
    GameData: {},
    Scenes: {},
  },
  MatchingShadowsConfigurable: {
    GameData: {},
    Scenes: {},
  },
  MatchingShadowsAnimals: {
    GameData: {},
    Scenes: {},
  },
  MatchingShadowsFish: {
    GameData: {},
    Scenes: {},
  },
  SynonymRolls: {
    GameData: {},
    Scenes: {},
  },
  MatchOpposites: {
    GameData: {},
    Scenes: {},
  },
  Antonyms: {
    GameData: {},
    Scenes: {},
  },
  IdentifyTheFeeling: {
    GameData: {},
    Scenes: {},
  },
  CountByDragging: {
    GameData: {},
    Scenes: {},
  },
  MatchingWords: {
    GameData: {},
    Scenes: {},
  },
  IdentifyRhymingWords: {
    GameData: {},
    Scenes: {},
  },
  CountAlong: {
    GameData: {},
    Scenes: {},
  },
  TranslateTenFrameToNumber: {
    GameData: {},
    Scenes: {},
  },
  TranslateNumberToTenFrame: {
    GameData: {},
    Scenes: {},
  },
  IdentifyTheSeason: {
    GameData: {},
    Scenes: {},
  },
  SeasonsOrdering: {
    GameData: {},
    Scenes: {},
  },
  SentencePartsChalkboard: {
    GameData: {},
    Scenes: {},
  },
  IdentifyPartsInASentence: {
    GameData: {},
    Scenes: {},
  },
  CountAndCompareGroups: {
    GameData: {},
    Scenes: {},
  },
  CountGroupsAndCompare: {
    GameData: {},
    Scenes: {},
  },
  CopyPattern: {
    GameData: {},
    Scenes: {},
  },
  MatchThePattern: {
    GameData: {},
    Scenes: {},
  },
  BasketballBinary: {
    GameData: {},
    Scenes: {},
  },
  IsItAStatementOrAQuestion: {
    GameData: {},
    Scenes: {},
  },
  CompleteTheRhyme: {
    GameData: {},
    Scenes: {},
  },
  ShortVsLongVowels: {
    GameData: {},
    Scenes: {},
  },
  CountTheTallyMarks: {
    GameData: {},
    Scenes: {},
  },
  BowlingBinaryAnswer: {
    GameData: {},
    Scenes: {},
  },
  SortingPlatforms: {
    GameData: {},
    Scenes: {},
  },
  MonkeyImagesToText: {
    GameData: {},
    Scenes: {},
  },
  WhichInterrogativeWord: {
    GameData: {},
    Scenes: {},
  },
  WhichSumEqualsTheNumber: {
    GameData: {},
    Scenes: {},
  },
  BullseyeMatchText: {
    GameData: {},
    Scenes: {},
  },
  NumberLineMissingNumber: {
    GameData: {},
    Scenes: {},
  },
  NumberLineSimpleMissing: {
    GameData: {},
    Scenes: {},
  },
  WordProblemPirates: {
    GameData: {},
    Scenes: {},
  },
  PiratesMatchText: {
    GameData: {},
    Scenes: {},
  },
  CountItemsAndIncrement: {
    GameData: {},
    Scenes: {},
  },
  CountGroupAndAdd: {
    GameData: {},
    Scenes: {},
  },
  FillInTheNumberGrid: {
    GameData: {},
    Scenes: {},
  },
  NumberGrid: {
    GameData: {},
    Scenes: {},
  },
  DragImagesToMatch: {
    GameData: {},
    Scenes: {},
  },
  IdentifyPositions: {
    GameData: {},
    Scenes: {},
  },
  PirateChestPositions: {
    GameData: {},
    Scenes: {},
  },
  IdentifyDifferentItem: {
    GameData: {},
    Scenes: {},
  },
  DetectiveMultipleChoice: {
    GameData: {},
    Scenes: {},
  },
  CountShapesSides: {
    GameData: {},
    Scenes: {},
  },
  ImageQuestionToImagesAnswers: {
    GameData: {},
    Scenes: {},
  },
  IdentifyNounType: {
    GameData: {},
    Scenes: {},
  },
  CategorizationSimpleFrame: {
    GameData: {},
    Scenes: {},
  },
  IdentifyGridPositions: {
    GameData: {},
    Scenes: {},
  },
  SoundsMultichoice: {
    GameData: {},
    Scenes: {},
  },
  ConsonantSounds: {
    GameData: {},
    Scenes: {},
  },
  ConfusingLetters: {
    GameData: {},
    Scenes: {},
  },
  SoundsBinary: {
    GameData: {},
    Scenes: {},
  },
  WordsWithMissingLetters: {
    GameData: {},
    Scenes: {},
  },
  MissingLetters: {
    GameData: {},
    Scenes: {},
  },
  CompleteTo10: {
    GameData: {},
    Scenes: {},
  },
  FindTheVowels: {
    GameData: {},
    Scenes: {},
  },
  CarouselImageMulti: {
    GameData: {},
    Scenes: {},
  },
  SentenceEndingPunctuation: {
    GameData: {},
    Scenes: {},
  },
  RacecarImageSelect: {
    GameData: {},
    Scenes: {},
  },
  BucketOddAndEvenNumbers: {
    GameData: {},
    Scenes: {},
  },
  BinaryTextToImage: {
    GameData: {},
    Scenes: {},
  },
  SoundsSorting: {
    GameData: {},
    Scenes: {},
  },
  SortSoundsToMakeAWord: {
    GameData: {},
    Scenes: {},
  },
  ImageMultiselectNoQuestion: {
    GameData: {},
    Scenes: {},
  },
  MatchSimilarItems: {
    GameData: {},
    Scenes: {},
  },
  SoundToTextAnswers: {
    GameData: {},
    Scenes: {},
  },
  PickWordsWithBeginningSound: {
    GameData: {},
    Scenes: {},
  },
  ImageBinary: {
    GameData: {},
    Scenes: {},
  },
  LowercaseOrUppercaseLetters: {
    GameData: {},
    Scenes: {},
  },
  MatchingLettersInGroup: {
    GameData: {},
    Scenes: {},
  },
  SelectMatchingLetters: {
    GameData: {},
    Scenes: {},
  },
  SelectMatchingImages: {
    GameData: {},
    Scenes: {},
  },
  MatchingImagesInGroup: {
    GameData: {},
    Scenes: {},
  },
  MultipleChoice: {
    GameData: {},
    Scenes: {},
  },
  FillInTheBlanks: {
    GameData: {},
    Scenes: {},
  },
};

export default EDC;
